import { types } from "../types/types";

const initialState = {
  catalogContinent: {},
  catalogContinents: [],
  catalogContinentsP: [],
  catalogContinentsS: [],

  totalItemsP: 0,
  totalPagesP: 0,
  currentPageP: 0,
  
  totalItemsS: 0,
  totalPagesS: 0,
  currentPageS: 0,
  searchTextState: "",
};
export const catalogContinentReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CONTINENT_SELECT:
      return {
        ...state,
        catalogContinent: action.payload,
      };

    case types.CONTINENT_UPDATE:
      if (state.catalogContinentsS.length > 0) {
        return {
          ...state,
          catalogContinentsS: state.catalogContinentsS.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
          catalogContinentsP: state.catalogContinentsP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      } else {
        return {
          ...state,
          catalogContinentsP: state.catalogContinentsP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      }

    case types.CONTINENT_DELETE:
      if (state.catalogContinentsS.length > 0) {
        return {
          ...state,
          catalogContinentsS: state.catalogContinentsS.filter((usr) => usr.id !== action.payload),
          catalogContinentsP: state.catalogContinentsP.filter((usr) => usr.id !== action.payload),
          catalogContinent: {},
        };
      } else {
        return {
          ...state,
          catalogContinentsP: state.catalogContinentsP.filter((usr) => usr.id !== action.payload),
          catalogContinent: {},
        };
      }

    case types.CONTINENT_START_LOADING:
      return {
        ...state,
        catalogContinents: action.payload,
      };

    case types.CONTINENT_START_LOADING_PAGINATED:
      return {
        ...state,
        catalogContinentsP: action.payload.continentsP,
        totalItemsP: action.payload.totalItems,
        totalPagesP: action.payload.totalPages,
        currentPageP: action.payload.currentPage,
      };

    case types.CONTINENT_START_SEARCH:
      return {
        ...state,
        catalogContinentsS: action.payload,
      };

    case types.CONTINENT_START_SEARCH_PAGINATED:
      return {
        ...state,
        catalogContinentsS: action.payload.continentsP,
        totalItemsS: action.payload.totalItems,
        totalPagesS: action.payload.totalPages,
        currentPageS: action.payload.currentPage,
      };

    case types.CONTINENT_CLEAN_SEARCH_PAGINATED:
      return {
        ...state,
        catalogContinentsS: [],
      };

    case types.CONTINENT_CLEAN:
      return {
        ...state,
        catalogContinent: {},
      };

    case types.CONTINENT_START_REGISTER:
      return {
        ...state,
        catalogContinent: action.payload,
      };

    case types.CONTINENT_SET_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: action.payload,
      };

    case types.USER_CLEAN_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: "",
      };

    default:
      return state;
  }
};
